module.exports = __webpack_public_path__ + "static/media/protection-of-personal-data.9ed157f2.pdf";